import Reveal from "./Reveal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full opacity-60"
        style={{ background: "radial-gradient(circle, oklch(var(--primary-200)) 0%, transparent 70%)" }}
      ></div>
      <div className="mx-auto grid max-w-[1200px] items-center gap-10 px-4 pb-16 pt-28 md:px-6 md:pb-20 lg:grid-cols-[1.1fr_0.9fr] lg:pt-36">
        <div>
          <Reveal>
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-600">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
              </span>
              瓜田热点 · 传播观察站
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="font-heading text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
              每一场<span className="text-primary-500">爆火的吃瓜事件</span>
              <br />
              背后都有一份被写好的剧本
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              事件营销怎么被策划？幕后推手是谁？舆论为何总被来回牵着走？
              我们聚焦吃瓜事件背后的传播运作，从流量链条到真实动机，带你穿透表面看本质，做一个不迷路的理性吃瓜人。
            </p>
          </Reveal>
          <Reveal delay={240}>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#hot"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                看本周瓜田热度榜
                <i className="ri-arrow-down-line" aria-hidden="true"></i>
              </a>
              <a
                href="#deep"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-quill-pen-line" aria-hidden="true"></i>
                读深扒专栏
              </a>
            </div>
          </Reveal>
          <Reveal delay={320}>
            <div className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {[
                { v: "24 小时", l: "热点换防周期" },
                { v: "4 大", l: "传播拆解视角" },
                { v: "理性", l: "不站队只还原" },
              ].map((s) => (
                <div key={s.l}>
                  <p className="font-heading text-xl font-black text-primary-600 md:text-2xl">{s.v}</p>
                  <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.l}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20vintage%20magazine%20collage%20art%20of%20people%20eating%20watermelon%20and%20watching%20a%20glowing%20trending%20screen%20full%20of%20floating%20speech%20bubbles%20and%20fire%20icons%2C%20warm%20cream%20background%20with%20terracotta%20red%20and%20golden%20amber%20accents%2C%20hand%20drawn%20grains%2C%20vintage%20print%20poster%20aesthetic%2C%20flat%20graphic%20design%2C%20high%20detail&width=900&height=760&seq=gua-hero-2026&orientation=portrait"
                alt="吃瓜事件热度与舆论传播示意图"
                title="吃瓜事件热度与舆论传播"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -left-4 top-8 hidden rounded-xl border border-background-200 bg-background-50/95 px-4 py-3 shadow-sm sm:block">
              <p className="text-xs text-foreground-500">今日瓜田热词</p>
              <p className="mt-1 flex items-center gap-2 font-heading text-sm font-bold text-foreground-900">
                <i className="ri-fire-fill text-accent-500" aria-hidden="true"></i>
                真相 vs 推手
              </p>
            </div>
            <div className="absolute -bottom-5 right-4 hidden rounded-xl border border-background-200 bg-background-50/95 px-4 py-3 shadow-sm sm:block">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-focus-2-line text-primary-500" aria-hidden="true"></i>
                穿透流量 · 看见真相
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}